import { CERealizationAttributesBase } from './ce-realization-attributes-base'


export class CERealizationAttributes extends CERealizationAttributesBase {

}